/* eslint-disable no-unused-vars */
export enum CTAType {
  DEFAULT = 'default',
  FUNNEL = 'funnel',
}
